import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Box from '@amzn/awsui-components-console/box';
import Table from '@amzn/awsui-components-console/table';
import Badge from '@amzn/awsui-components-console/badge';
import { COMPARISON_ITEMS, ComparisonItem } from '../../constants';
import { useTranslation } from 'src/i18n/shim/useTranslation';
import styles from './AstVsLangHub.module.scss';

const AstVsLangHub: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      aria-label={t('landing-comparison-heading')}
      className={styles.section}
      id="ast-vs-langhub"
    >
      <Container>
        <SpaceBetween size="l">
          <Box textAlign="center">
            <SpaceBetween size="xs">
              <Box
                variant="h2"
                fontSize="heading-xl"
                fontWeight="bold"
                textAlign="center"
              >
                {t('landing-comparison-heading')}
              </Box>
              <Box variant="p" color="text-body-secondary" textAlign="center">
                {t('landing-comparison-body')}
              </Box>
            </SpaceBetween>
          </Box>
          <div className={styles.tableWrapper}>
            <Table<ComparisonItem>
              variant="borderless"
              // Keyed on the resource id: the rendered name now varies by locale.
              trackBy="capabilityId"
              wrapLines={true}
              sortingDisabled={true}
              columnDefinitions={[
                {
                  id: 'capability',
                  header: (
                    <Box variant="strong">
                      {t('landing-comparison-col-capability')}
                    </Box>
                  ),
                  minWidth: 160,
                  cell: (item) => (
                    <Box variant="strong">{t(item.capabilityId)}</Box>
                  ),
                },
                {
                  id: 'ast',
                  // Product names, so these two headers stay literal.
                  header: <Box variant="strong">AST</Box>,
                  minWidth: 180,
                  cell: (item) => (
                    <Box color="text-status-inactive">{t(item.astId)}</Box>
                  ),
                },
                {
                  id: 'langhub',
                  header: <Box variant="strong">LangHub</Box>,
                  minWidth: 220,
                  cell: (item) => (
                    <SpaceBetween
                      direction="horizontal"
                      size="xs"
                      alignItems="center"
                    >
                      <Box display="inline">{t(item.langhubId)}</Box>
                      {item.comingSoon ? (
                        <Badge color="severity-medium">
                          {t('landing-comparison-coming-soon')}
                        </Badge>
                      ) : null}
                    </SpaceBetween>
                  ),
                },
              ]}
              items={COMPARISON_ITEMS}
            />
          </div>
        </SpaceBetween>
      </Container>
    </section>
  );
};

export default AstVsLangHub;
